var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "pop-up-add-include" }, [
          _c(
            "div",
            { staticClass: "pop-up__close", on: { click: _vm.closeWindow } },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/svg/close.svg"),
                  alt: "close",
                },
              }),
            ]
          ),
          _vm.have_error && _vm.errorText
            ? _c("div", { staticClass: "pop-up-add-include__errors" }, [
                _vm._m(0),
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    " " + _vm._s(_vm.includeTranslate.textError.text) + " "
                  ),
                ]),
                _c("div", { staticClass: "error-type" }, [
                  _c("div", { staticClass: "description" }, [
                    _vm._v(" " + _vm._s(_vm.errorText) + " "),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "pop-up-add-include__title" }, [
            _vm._v(_vm._s(_vm.includeTranslate.title.text)),
          ]),
          _c("div", { staticClass: "pop-up-add-include__subtitle" }, [
            _vm._v(_vm._s(_vm.includeTranslate.subtitle.text)),
          ]),
          _c("div", { staticClass: "pop-up-add-include__content" }, [
            _c("div", { staticClass: "category" }, [
              _c("div", { staticClass: "category__title" }, [
                _vm._v(_vm._s(_vm.includeTranslate.contentCategory.text)),
              ]),
              _c(
                "div",
                { staticClass: "category__selection" },
                [
                  _c("selection", {
                    attrs: {
                      default: "",
                      "default-name": _vm.categoryName,
                      items: _vm.selectionCategory,
                    },
                    on: { name: _vm.changeCategory },
                  }),
                ],
                1
              ),
            ]),
            _vm.categoryName == _vm.includeTranslate.ownCategory.text ||
            _vm.categoryName == _vm.includeTranslate.feesCategory.text
              ? _c("div", { staticClass: "info-type" }, [
                  _c("div", { staticClass: "info-type__other" }, [
                    _vm._m(1),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(
                        _vm._s(
                          _vm.categoryName ==
                            _vm.includeTranslate.ownCategory.text
                            ? _vm.includeTranslate.infotypeOwn.text
                            : _vm.includeTranslate.infotypeFees.text
                        )
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.categoryName == _vm.includeTranslate.ownCategory.text
              ? _c("div", { staticClass: "own-inclusion" }, [
                  _c(
                    "div",
                    { staticClass: "category__selection" },
                    [
                      _c("v-input", {
                        attrs: {
                          placeholder: _vm.includeTranslate.ownPlaceholder.text,
                          label: _vm.includeTranslate.contentTitle.text,
                          "max-length": 100,
                        },
                        model: {
                          value: _vm.ownInclusion,
                          callback: function ($$v) {
                            _vm.ownInclusion = $$v
                          },
                          expression: "ownInclusion",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.categoryName != _vm.includeTranslate.categoryDefault.text &&
            _vm.categoryName != _vm.includeTranslate.ownCategory.text
              ? _c("div", { staticClass: "include" }, [
                  _c("div", { staticClass: "category__title" }, [
                    _vm._v(_vm._s(_vm.includeTranslate.contentTitle.text)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "category__selection" },
                    [
                      _c("selection", {
                        attrs: {
                          default: "",
                          "default-name": _vm.includeName,
                          items: _vm.selectionTitles,
                        },
                        on: { name: _vm.changeIncludes },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "pop-up-add-include__nav" }, [
            _c(
              "div",
              { staticClass: "cancel", on: { click: _vm.closeWindow } },
              [
                _c("Btn", {
                  attrs: {
                    outline: "",
                    name: _vm.includeTranslate.cancelBtn.text,
                    disabled: _vm.BtnDesabled,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "Add", on: { click: _vm.saveNewInclude } },
              [
                _c("Btn", {
                  attrs: {
                    base: "",
                    name: _vm.includeTranslate.addBtn.text,
                    disabled: _vm.BtnDesabled,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/svg/error.svg"), alt: "info" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/svg/info.svg"), alt: "info" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }